module.exports = __webpack_public_path__ + "static/media/Purchase1.4e345ba6.png";